export default "__VITE_ASSET__CLvGu8ee__"